module.exports = __webpack_public_path__ + "static/media/VidgoDevicesMobileView.14811d8e.png";